import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { Emoji } from 'images'
import { Link } from 'ui'

import { SWEATBITS_TEXT } from '../../constants'

class Footer extends PureComponent {
  render() {
    return (
      <div className={classnames('bg-white p-2', this.props.className)} data-dark-mode="true">
        <div className="flex flex-wrap justify-around *:p-2 gap-2 *:min-w-72 *:max-w-144">
          <div>
            <div className="text-grey uppercase pb-2">Plataforma</div>
            <div className="flex flex-col gap-1 *:!text-text text-sm">
              <Link href="/platform">Información</Link>
              <Link as="a" className="!text-text" href="https://status.sweatbits.co" target="_blank">
                Estado de nuestros servicios
              </Link>
            </div>
          </div>
          <div>
            <div className="text-grey uppercase pb-2">Recursos</div>
            <div className="flex flex-col gap-1 *:!text-text text-sm">
              <Link href="/platform/privacy">Términos del servicio</Link>
              <Link href="/platform/privacy">Política de privacidad</Link>
            </div>
          </div>
          <div>
            <div className="text-grey uppercase pb-2 text-center">Acércate a nosotros</div>
            <div className="flex items-center justify-center gap-1">
              <a
                className="ui circular mini facebook icon button"
                href="https://fb.com/SweatBits"
                rel="nofollow"
                target="fb"
                title="SweatBits @ Facebook"
              >
                <i className="facebook large icon" />
              </a>
              <a
                className="ui circular mini twitter icon button"
                href="https://twitter.com/SweatBits"
                rel="nofollow"
                target="tw"
                title="SweatBits @ Twitter"
              >
                <i className="twitter large icon" />
              </a>
              <a
                className="ui circular mini instagram icon button"
                href="https://instagram.com/SweatBits"
                rel="nofollow"
                target="in"
                title="SweatBits @ Instagram"
              >
                <i className="instagram large icon" />
              </a>
              <a
                className="ui circular mini youtube icon button"
                href="https://youtube.com/channel/UCjhe7djc9AI-RJyQqelKMZQ"
                rel="nofollow"
                target="yo"
                title="SweatBits @ Youtube"
              >
                <i className="youtube large icon" />
              </a>
            </div>
            <div className="text-xs p-1 text-center">
              Hecho en Colombia <Emoji className="text-2xl" name="flag-co" />
            </div>
          </div>
        </div>
        <div className="text-center text-sm p-2">&copy; 2017 {SWEATBITS_TEXT}. Todos los derechos reservados.</div>
      </div>
    )
  }
}

Footer.propTypes = {
  className: PropTypes.string,
}

Footer.defaultProps = {
  className: null,
}

export default Footer
